export default "__VITE_ASSET__DlY7UFTK__"